const common = {
    state: {
        warehouse: null,
        showMobileFooter: true,
        mobileTitle: '',
        showBaleControl: false,
        showLabelingControl: false,
    },
    getters:{
        getWarehouse(state){
            return state.warehouse
        },
        getShowMobileFooter(state){
            return state.showMobileFooter
        },
        getMobileTitle(state){
            return state.mobileTitle
        },
        getShowBaleControl(state){
            return state.showBaleControl
        },
        getShowLabelingControl(state){
            return state.showLabelingControl
        },
    },
    mutations: {
        saveWarehouse(state, data) {
            state.warehouse = data;
            window.localStorage.setItem("warehouse", JSON.stringify(data));
        },
        changeShowMobileFooter(state, data) {
            state.showMobileFooter = data;
            window.localStorage.setItem("showMobileFooter", data);
        },
        saveMobileTitle(state, data) {
            state.mobileTitle = data;
            window.localStorage.setItem("mobileTitle", data);
        },
        changeShowBaleControl(state, data) {
            state.showBaleControl = data;
            window.localStorage.setItem("showBaleControl", data);
        },
        changeShowLabelingControl(state, data) {
            state.showLabelingControl = data;
            window.localStorage.setItem("showLabelingControl", data);
        },
    },
    actions: {
    }
}

export default common